<template>

	<div>
	
		<div v-if="tb.csstype&&tb.csstype=='a'">
			<!-- <div v-if="'a'"> -->
			<div   class="weui-cell" style="border-bottom: 1px solid rgba(0,0,0,0.1);">        
				<div class="weui-cell__hd"  style="width:120px;padding-bottom: 5px;">
					<font style="color: red;"  v-if="tb.ismust">*</font>
					<font>{{tb.name}}</font>      
				</div>
				
				<label  style="flex:1;padding-bottom: 5px;">
				  <input 
				  :readonly = "tb.autowrite=='a'"
				  :name="'biaodan'+tv" 
				  :style="{color:tb.val?'black':'rgb(161, 157, 157)'}" :id="'textbox'+tv"                 
				  style="width:80%;background-color:transparent"
					   v-model="tb.val"
					:placeholder="tb.placeholder?tb.placeholder:('请输入'+tb.name)"	
								
				  />
				</label> 
				<a v-if="tb.val&&tb.autowrite!='a'" @click="tb.val=''" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a>             
			</div>		
		</div>
	
	
		<div v-else-if="tb.csstype&&tb.csstype=='b'" style="position: relative;">
			<label :for="tb.name" style="font-weight: normal;">
				<font style="color: red;" v-if="tb.ismust">*</font>
				<font style="color: red;" v-else="tb.ismust">&nbsp </font>
				{{tb.name}}			
			</label>
			<div style="font-size:14px;opacity:0.5">{{tb.placeholder}}</div>
			<div class = 'ddcss'  style="display: flex;align-items:center;width: 98%;" 
		>
				<input
				:readonly = "tb.autowrite=='a'"
				:type="tb.type?tb.type:'text'" v-model="tb.val" :id="'textbox'+tv"  :name="'biaodan'+tv"
				
				style="width:100%;background-color: transparent;
			   caret-color: rgb(148, 146, 146);padding: 3px;color:#313030
			   ">
			   <i v-if="tb.val&&tb.autowrite!='a'" @click = "tb.val=''" class="weui-icon-clear" ></i>
			</div>
	
		
		
		</div>
	
	
	
		<div class="xinput" v-else>
			<label :for="tb.name" style="font-weight: normal;">
				<font style="color: red;" v-if="tb.ismust">*</font>
				<font style="color: red;" v-else="tb.ismust">&nbsp </font>
				{{tb.name}}
			</label>
			<input
			 :type="tb.type?tb.type:'text'"
			  v-model="tb.val" :id="'textbox'+tv" 
			  :name="'biaodan'+tv"
			   @focus= 'getfo'
			   @blur = 'losebl'
			   :style="{color:co?'red':''}"
				:placeholder="tb.placeholder?tb.placeholder:('请输入'+tb.name)"
				:readonly = "tb.autowrite=='a'"
				>
				 
		</div>
	
	
	</div>
	
	
	
	
	
	
	
	
	</template>
	
	<script>
		
		export default {
			name: 'TexBox',
			props: ["tb","tv"],
			data(){
				return{
					co:false,
					cborder:{}
				}
			},
			activated(){
				
				if(this.tb.autowrite&&this.tb.autowrite=="a"){
					let account = this.$store.state.account;
					this.tb.val = account;
				}
			},
			created(){
				if(this.tb.autowrite&&this.tb.autowrite=="a"){
					let account = this.$store.state.account;
					this.tb.val = account;
				}
			},
			methods:{
				getfo(){
					this.co = false;				
				},
				losebl(){
					if(this.tb.type=='email'){
						if(!/.+@.+/.test(this.tb.val))
						this.co = true;					
					}
					if(this.tb.type =='tel')
					{
						if(!/^1[3456789]\d{9}$/.test(this.tb.val)){
							this.co = true;
						}
					}
					
				}
			}
		}
	</script>
	
	<style scoped="scoped" lang="less">
		.xinput {
			input {
				width: 95%;
				height: 36px;
				background: #fcfcfc;
				border: 1px solid #f3f3f3;
				-moz-border-radius: 2px;
				-webkit-border-radius: 2px;
				border-radius: 2px;
				-moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1) inset;
				-webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1) inset;
				box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1) inset;
				font-family: 'PT Sans', Helvetica, Arial, sans-serif;
				color: #666666;
				font-size: 18px;
			}
	
			input:focus {
				border: 1px solid #ddd;
				outline: none;
				background-color:#fcffe0;
			}
	
			label {
				margin: 7px 0 10px 5px;
				font-size: 16px;
				text-align: left;
			}
		}
		.ddcss{
			border:solid 1px rgb(145, 141, 141)
		}
		.ddcss:focus-within{
			border:solid 1px rgb(133, 148, 212);
		}
	</style>
	


// WEBPACK FOOTER //
// src/fields/TextBox.vue